import range from 'lodash/range';
import styled from 'styled-components';

import { colors } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';

import { Typography as T } from './Typography/Typography';
import { useFormatMessage } from '../../hooks/useFormatMessage';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StepContainer = styled.div<{ $count: number }>`
  display: grid;
  grid-template-columns: ${({ $count }) => `repeat(${$count}, 1fr)`};
  gap: 16px;
`;

const Step = styled.button<{ $selected: boolean }>`
  height: 4px;
  background: ${({ $selected }) => ($selected ? color.bgFillBrand : colors.pepper40)};
  border-radius: 2px;
  border: 0;
`;

const Text = styled(T.bodyLabel)`
  color: ${color.textSubdued};
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

type Props = {
  current: number;
  total: number;
  className?: string;
};

export const MobileWizardProgress: React.FC<Props> = ({ current, total, className }) => {
  const format = useFormatMessage();

  return (
    <Root className={className}>
      <StepContainer $count={total}>
        {range(total).map((index) => {
          const number = index + 1;
          return <Step key={number} $selected={number === current} />;
        })}
      </StepContainer>
      <Text>{format('components.mobile_wizard_progress.step_n_of_n', { current, total })}</Text>
    </Root>
  );
};
